import { useDesignMaxTheme } from "@/packages";
import { usePensionNameValue } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Grid, Text } from "@chakra-ui/react";
import { OtherRoom } from "./components";

export const OtherRoomPreView = ({ roomList }: { roomList: RoomType[] }) => {
    const pensionName = usePensionNameValue();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center position="relative" w="100%">
            <Center as="section">
                <Center flexDir="column" gap="64px">
                    <Box textAlign="center">
                        <Text {...FONT("cormorant", isMobile ? 32 : 56, 700, 1.2)}>OTHER</Text>
                        <Box
                            sx={{
                                "& p": {
                                    ...FONT("pretendard", isMobile ? 12 : 18, 300, 1.4),
                                    color: "#333",
                                },
                            }}
                        >
                            <Text>다양한 즐길거리와 볼거리가 가득한 {pensionName.kor}에서</Text>
                            <Text>사랑하는 가족, 연인, 친구들과 잊지못할 추억을 만들어 보세요.</Text>
                        </Box>
                    </Box>
                    <Grid p="0 20px" w="100%" templateColumns={`repeat(${isMobile ? "1" : "2"},1fr)`} gridGap="24px">
                        {roomList.map((room) => (
                            <OtherRoom key={room.room_idx} room={room} />
                        ))}
                    </Grid>
                </Center>
            </Center>
        </Center>
    );
};
